<template>
    <layout-gestao v-cloak>
        <div class="row no-gutters">
            <div class="col-sm-12">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <h1 class="content-title">{{ this.title }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../mixin'

    export default {
        mixins: [mixin],
        data() 
        {
            return {
                
            }
        },
        mounted()
        {
            
        },
        computed: {
            moduleName(){
                return this.$store.getters[`${this.moduleCode}/getModuleName`];
            },
            title() {
                return `${this.moduleName}`
                // return `${this.pageTitle} - ${this.moduleName}`
            },
        }
    }
</script>

<style scoped lang="scss">

</style>